
(function() {
  'use strict';

  var PINK = '#f099bd';
  var SAGE = '#96aca4';

  var ROUNDED_STAR_PATH =
    'M50,5 ' +
    'C53,5 56,12 54,18 ' +
    'C52,24 58,26 63,22 ' +
    'C68,18 76,20 77,25 ' +
    'C78,30 72,35 67,34 ' +
    'C62,33 61,39 65,44 ' +
    'C69,49 68,57 63,58 ' +
    'C58,59 54,53 50,53 ' +
    'C46,53 42,59 37,58 ' +
    'C32,57 31,49 35,44 ' +
    'C39,39 38,33 33,34 ' +
    'C28,35 22,30 23,25 ' +
    'C24,20 32,18 37,22 ' +
    'C42,26 48,24 46,18 ' +
    'C44,12 47,5 50,5 Z';

  // Returns responsive config based on current viewport width.
  // sizeMult: multiply desktop star sizes by this factor.
  // maxStars: maximum number of stars to render per section.
  // edge:     maximum % value allowed for left/right positioning.
  // showArrows: whether to render curved arrows.
  function getConfig() {
    var w = window.innerWidth;
    if (w < 480) {
      return { sizeMult: 0.25, maxStars: 2, edge: '1%', showArrows: false };
    } else if (w < 768) {
      return { sizeMult: 0.50, maxStars: 3, edge: '2%', showArrows: false };
    }
    return { sizeMult: 1, maxStars: Infinity, edge: null, showArrows: true };
  }

  // Clamp a percentage position string to stay within the allowed edge.
  // e.g. clampEdge('8%', '2%') => '2%'
  function clampEdge(val, maxEdge) {
    if (!maxEdge || !val) return val;
    var num = parseFloat(val);
    var max = parseFloat(maxEdge);
    if (isNaN(num) || isNaN(max)) return val;
    return Math.min(num, max) + '%';
  }

  function makeStar(color, size, opacity) {
    opacity = opacity || 1;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', ns);
    svg.style.cssText = 'display:block;pointer-events:none;';
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', ROUNDED_STAR_PATH);
    path.setAttribute('fill', color);
    path.setAttribute('fill-opacity', String(opacity));
    svg.appendChild(path);
    return svg;
  }

  function makeArrow() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '80');
    svg.setAttribute('height', '100');
    svg.setAttribute('viewBox', '0 0 80 100');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', ns);
    svg.style.cssText = 'display:block;pointer-events:none;';
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M10 5 C10 5, 60 20, 65 55 C70 80, 45 90, 30 88');
    path.setAttribute('stroke', '#1a1a1a');
    path.setAttribute('stroke-width', '2.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('fill', 'none');
    svg.appendChild(path);
    var arrowHead = document.createElementNS(ns, 'path');
    arrowHead.setAttribute('d', 'M18 82 C18 82, 28 90, 30 88 C32 86, 24 78, 24 78');
    arrowHead.setAttribute('stroke', '#1a1a1a');
    arrowHead.setAttribute('stroke-width', '2.5');
    arrowHead.setAttribute('stroke-linecap', 'round');
    arrowHead.setAttribute('fill', 'none');
    svg.appendChild(arrowHead);
    return svg;
  }

  function makeWrapper(top, left, right) {
    var div = document.createElement('div');
    div.style.cssText = [
      'position:absolute',
      'pointer-events:none',
      'z-index:1',
      top ? 'top:' + top : '',
      left ? 'left:' + left : '',
      right ? 'right:' + right : ''
    ].filter(Boolean).join(';') + ';';
    return div;
  }

  function decorateSection(section, decorations) {
    if (!section) return;
    var cfg = getConfig();
    var pos = window.getComputedStyle(section).position;
    if (pos === 'static') section.style.position = 'relative';

    // Separate stars and arrows; apply maxStars limit to stars only.
    var stars = decorations.filter(function(d) { return d.type !== 'arrow'; });
    var arrows = decorations.filter(function(d) { return d.type === 'arrow'; });
    var visibleStars = stars.slice(0, cfg.maxStars);
    var visibleArrows = cfg.showArrows ? arrows : [];
    var visible = visibleStars.concat(visibleArrows);

    visible.forEach(function(d) {
      var left = d.left ? clampEdge(d.left, cfg.edge) : null;
      var right = d.right ? clampEdge(d.right, cfg.edge) : null;
      var wrapper = makeWrapper(d.top, left, right);
      var el;
      if (d.type === 'arrow') {
        el = makeArrow();
      } else {
        var scaledSize = Math.round(d.size * cfg.sizeMult);
        el = makeStar(d.color, scaledSize, d.opacity);
      }
      wrapper.appendChild(el);
      section.appendChild(wrapper);
    });
  }

  function init() {

    // ── Banner / Header area ──────────────────────────────────────────────
    var bannerSection = document.querySelector('.shopify-section:first-of-type, [class*="slideshow"], [class*="banner"], [class*="hero"], [class*="header-section"]');
    if (bannerSection) {
      decorateSection(bannerSection, [
        { type: 'star', color: PINK, size: 70, top: '12%', left: '3%' },
        { type: 'star', color: SAGE, size: 46, top: '8%',  left: '8%' },
        { type: 'star', color: PINK, size: 30, top: '25%', left: '5%' },
        { type: 'star', color: SAGE, size: 80, top: '10%', right: '4%' },
        { type: 'star', color: PINK, size: 40, top: '30%', right: '8%' },
        { type: 'star', color: SAGE, size: 26, top: '45%', right: '3%' }
      ]);
    }

    // ── Category highlights / feature sections ────────────────────────────
    var allSections = document.querySelectorAll('.shopify-section');
    var categorySections = [];
    allSections.forEach(function(s) {
      var text = s.innerText || '';
      if (
        text.toLowerCase().indexOf('personaliz') !== -1 ||
        text.toLowerCase().indexOf('festas') !== -1 ||
        text.toLowerCase().indexOf('revendedor') !== -1 ||
        s.querySelector('[class*="feature"], [class*="highlight"], [class*="category"], [class*="promo"]')
      ) {
        categorySections.push(s);
      }
    });

    if (categorySections.length > 0) {
      var catSection = categorySections[0];
      decorateSection(catSection, [
        { type: 'star', color: SAGE, size: 64, top: '5%',  left: '1%' },
        { type: 'star', color: PINK, size: 38, top: '15%', left: '6%' },
        { type: 'star', color: PINK, size: 52, top: '5%',  right: '2%' },
        { type: 'star', color: SAGE, size: 32, top: '20%', right: '7%' }
      ]);
    }

    // ── Blog section ──────────────────────────────────────────────────────
    var blogSection = null;
    allSections.forEach(function(s) {
      var text = s.innerText || '';
      if (
        text.toLowerCase().indexOf('blog') !== -1 ||
        s.querySelector('[class*="blog"], [class*="article"], [class*="post"]')
      ) {
        blogSection = s;
      }
    });

    if (blogSection) {
      decorateSection(blogSection, [
        { type: 'star',  color: PINK, size: 58, top: '8%',  left: '2%' },
        { type: 'star',  color: SAGE, size: 35, top: '20%', left: '7%' },
        { type: 'star',  color: SAGE, size: 75, top: '5%',  right: '3%' },
        { type: 'star',  color: PINK, size: 26, top: '25%', right: '9%' },
        { type: 'arrow', top: '15%', left: '1%' }
      ]);
    }

    // ── Fallback: scatter stars on any remaining sections ─────────────────
    if (!bannerSection && categorySections.length === 0 && !blogSection) {
      var firstSection = document.querySelector('.shopify-section');
      if (firstSection) {
        decorateSection(firstSection, [
          { type: 'star', color: PINK, size: 58, top: '10%', left: '3%' },
          { type: 'star', color: SAGE, size: 40, top: '20%', right: '4%' },
          { type: 'star', color: PINK, size: 30, top: '35%', left: '7%' }
        ]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
